import React, { useState } from "react";
import LowVoltage from "../Voltages/LV/LV";
import MediumVoltage from "../Voltages/MV/MV";
import HighVoltage from "../Voltages/HV/HV";
import HierarchicalSidebar from "../../utils/HierarchicalSidebar/HierarchicalSidebar";

const HeaderMenu = ({
  setWfsLayers,
  setHoverInfo,
  setClickInfo,
  setLayersToggle,
  setWmsLayers,
  setSubstationOptions,
  substationOptions,
  viewState,
  setViewState,
  setIsTrafoActive,
  wfsLayers,
  setOverlay,
  id_terenske_jedinice,
  setIsOhActiveExtern,
  setNetworkType,
}) => {
  const [activeTab, setActiveTab] = useState("NN");
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [sidebarContent, setSidebarContent] = useState(null);
  const [sidebarTitle, setSidebarTitle] = useState("Hijerarhija trafopodručja");

  const handleSidebarToggle = (content, title = "Hijerarhija trafopodručja") => {
    setSidebarContent(content);
    setSidebarTitle(title);
    setIsSidebarVisible(true);
  };

  const closeSidebar = () => {
    setIsSidebarVisible(false);
    setSidebarContent(null);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "NN":
        return (
          <LowVoltage
            setWfsLayers={setWfsLayers}
            setHoverInfo={setHoverInfo}
            handleClickInfo={setClickInfo}
            setLayersToggle={setLayersToggle}
            setWmsLayers={setWmsLayers}
            handleSidebarToggle={handleSidebarToggle}
            handleSubstationOptions={setSubstationOptions}
            substationOptions={substationOptions}
            closeSidebar={closeSidebar}
            wfsLayers={wfsLayers}
            viewState={viewState}
            setViewState={setViewState}
            setIsTrafoActive={setIsTrafoActive}
            setOverlay={setOverlay}
            id_terenske_jedinice={id_terenske_jedinice}
            setIsOhActiveExtern={setIsOhActiveExtern}
            setNetworkType={setNetworkType}
          />
        );

      case "SN":
        return (
          <MediumVoltage
            setWfsLayers={setWfsLayers}
            setHoverInfo={setHoverInfo}
            handleClickInfo={setClickInfo}
            setLayersToggle={setLayersToggle}
            setWmsLayers={setWmsLayers}
            handleSidebarToggle={handleSidebarToggle}
            handleSubstationOptions={setSubstationOptions}
            substationOptions={substationOptions}
            closeSidebar={closeSidebar}
            wfsLayers={wfsLayers}
            viewState={viewState}
            setViewState={setViewState}
            setOverlay={setOverlay}
            id_terenske_jedinice={id_terenske_jedinice}
            setNetworkType={setNetworkType}
          />
        );

      case "VN":
        return (
          <HighVoltage
            setWfsLayers={setWfsLayers}
            setHoverInfo={setHoverInfo}
            setWmsLayers={setWmsLayers}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="menu-wrapper">
      <nav className="header-dropdown-menu">
        <div className="tabs">
          <button
            className={`tab ${activeTab === "NN" ? "active" : ""}`}
            onClick={() => setActiveTab("NN")}
          >
            NN
          </button>

          <button
            className={`tab ${activeTab === "SN" ? "active" : ""}`}
            onClick={() => setActiveTab("SN")}
          >
            SN
          </button>

          <button
            className={`tab ${activeTab === "VN" ? "active" : ""}`}
            onClick={() => setActiveTab("VN")}
          >
            VN
          </button>
        </div>

        <div className="tabs-content">{renderTabContent()}</div>
      </nav>

      {isSidebarVisible && (
        <HierarchicalSidebar
          title={sidebarTitle}
          content={sidebarContent}
          onClose={closeSidebar}
        />
      )}
    </div>
  );
};

export default HeaderMenu;